import React from 'react';
import { Link } from 'react-router-dom';

export const PRODUCT_NAME = 'BilledTwice AI';

export function BilledTwiceLogo({ size = 32 }) {
  return (
    <svg className="np-logo" width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <rect width="32" height="32" rx="8" fill="#121512" />
      <rect x="5" y="9.5" width="13.5" height="16" rx="2.2" fill="#0b0d0c" stroke="#5f7a56" strokeWidth="1.35" />
      <rect x="12.5" y="6.5" width="13.5" height="16" rx="2.2" fill="#171b17" stroke="#8fdc6b" strokeWidth="1.5" />
      <text
        x="19.2"
        y="20.4"
        textAnchor="middle"
        fill="#8fdc6b"
        fontFamily="Arial Black, Arial, sans-serif"
        fontSize="13"
        fontWeight="800"
      >
        2
      </text>
    </svg>
  );
}

export default function BrandMark({
  to,
  href,
  kicker,
  onClick,
  className = '',
  size = 32,
}) {
  const content = (
    <>
      <BilledTwiceLogo size={size} />
      <span className="np-mark-copy">
        BilledTwice AI
        {kicker ? <span>{kicker}</span> : null}
      </span>
    </>
  );
  const cls = className ? `np-mark ${className}` : 'np-mark';
  if (to) {
    return <Link to={to} className={cls} onClick={onClick}>{content}</Link>;
  }
  if (href) {
    return <a href={href} className={cls} onClick={onClick}>{content}</a>;
  }
  return <div className={cls}>{content}</div>;
}
